<template>
  <Dialog
    is-persistent
    :title="dialogTitle"
    :dialog="isOpened"
    :confirmation-button-text="confirmationButtonText"
    @confirmationAction="addEstimateRole"
  >
    <template #content>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-row class="pb-4">
          <v-col>
            <v-text-field
              id="project-estimate-role-input"
              v-model="estimateRole.name"
              data-cy="project-estimate-role-input"
              class="secondary-background"
              label="Role"
              type="string"
              hide-details
              required
              outlined
              dense
              :rules="[(bs) => !!bs?.trim() || 'Name is required']"
            />
          </v-col>
        </v-row>
        <!-- <v-row class="pb-4">
          <v-col>
            <v-textarea
              id="project-estimate-role-description-input"
              v-model="estimateRole.description"
              data-cy="project-estimate-role-input"
              class="secondary-background"
              label="Description"
              hide-details
              required
              outlined
              dense
              :rules="[(bs) => !!bs?.trim() || 'Description is required']"
            />
          </v-col>
        </v-row> -->
        <v-row class="pb-4">
          <v-col>
            <v-text-field
              id="project-estimate-role-rate-input"
              v-model="estimateRole.rate"
              data-cy="project-estimate-input"
              class="secondary-background"
              label="Rate"
              type="number"
              hide-details
              required
              outlined
              dense
              :rules="[(bs) => (bs > 0) || 'Rate is required',
                       (bs) => /^\d+(\.\d+)?$/.test(bs) || 'Rate must be a valid number']"
            />
          </v-col>
        </v-row>
        <!-- <v-row class="pb-4">
          <v-col>
            <v-text-field
              id="project-estimate-role-salary-input"
              v-model="estimateRole.salary"
              data-cy="project-estimate-input"
              class="secondary-background"
              label="Salary"
              type="number"
              hide-details
              required
              outlined
              dense
              :rules="[(bs) => (bs > 0) || 'Salary is required']"
            />
          </v-col>
        </v-row> -->
        <!-- <v-row class="pb-4">
          <v-col>
            <v-text-field
              id="project-estimate-role-overhead-input"
              v-model="estimateRole.overhead"
              data-cy="project-estimate-input"
              class="secondary-background"
              label="Overhead"
              type="number"
              hide-details
              required
              outlined
              dense
              :rules="[(bs) => (bs > 0) || 'overhead is required']"
            />
          </v-col>
        </v-row> -->
      </v-form>
    </template>
  </Dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { Dialog } from '@/components/shared';

const getInitialState = () => ({
  name: '',
  description: '',
  rate: 1,
  salary: 1,
  overhead: 1,
  project_id: '',
});

export default {
  components: {
    Dialog,
  },
  props: {
    isOpened: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      dialogTitle: 'Add estimation role',
      confirmationButtonText: 'Add',
      valid: true,
      estimateRole: getInitialState(),
    };
  },
  computed: {
    ...mapGetters('projects/main', ['project']),
    ...mapGetters('shared/roles', ['projectRoles']),
    ...mapGetters('shared/taskTypes', [
      'projectsTaskTypes',
    ]),

    form() {
      return { ...this.estimateRole };
    },
  },
  watch: {
  },
  created() {
    document.addEventListener('keydown', this.handleKeypress);
    document.addEventListener('keyup', this.handleKeyup);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleKeypress);
    document.removeEventListener('keyup', this.handleKeyup);
  },
  methods: {
    ...mapActions('projects/main', ['addProjectEstimationRole', 'getProjectEstimationRoles']),

    async addEstimateRole(confirmed) {
      if (!confirmed) {
        this.closeDialog();

        return;
      }

      if (!this.validate()) {
        return;
      }

      const role = {
        name: this.estimateRole.name,
        description: this.estimateRole.description,
        rate: this.estimateRole.rate,
        salary: this.estimateRole.salary,
        overhead: this.estimateRole.overhead,
      };

      try {
        await this.addProjectEstimationRole({
          role: {
            ...role,
            project_id: this.project.id,
          },
        });
        this.$emit('save');
        this.closeDialog();
      } catch (error) {
        if (error.response && error.response.data) {
          if (typeof error.response.data === 'string') {
            this.flashError(error.response.data);

            return;
          }

          if (error.response.data.message) {
            this.flashError(error.response.data.message);

            return;
          }
        }

        throw error;
      }
    },
    closeDialog() {
      this.$emit('close');
      this.reset();
      this.getProjectEstimationRoles({ projectId: this.project.id });
    },
    reset() {
      Object.assign(this.estimateRole, getInitialState());
      this.resetValidation();
    },
    validate() {
      return this.$refs.form.validate();
    },
    handleKeypress(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeDialog();
      }
    },
    handleKeyup(event) {
      if (event.key === 'Enter' && event.ctrlKey) {
        event.preventDefault();
        this.addEstimate();
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>
